// extracted by mini-css-extract-plugin
export default {"container":"calculator_container__b6ifl","breadCrumb":"calculator_breadCrumb__2OQEF"};